import {useForm} from "@inertiajs/react";
import React from "react";
import {Row, Col, Card, Form, Button, Image} from 'react-bootstrap';
import {useEnhancedTranslation} from "laravel-inertia-backend";

export default function Login(props) {
    const { t,getLocales } = useEnhancedTranslation();
    const {data, setData, post, errors} = useForm({
        login: "",
        password: "",
        remember: false,
    });

    const submitLogin = (e) => {
        e.preventDefault();
        post("/login");
    }

    return (
        <div style={{
            minHeight: '100vh',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            backgroundImage: `url(/images/background-login.jpg)`,
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            backgroundRepeat: 'no-repeat',
        }}>
            <Row className="d-flex justify-content-center" style={{width:'100%'}}>
                <Col md={6} style={{maxWidth: '800px'}}>
                    <h2><><Image src="/images/logo.png" alt="ordermail 2" style={{ height: '20px' }} /><div style={{fontSize:"12px", paddingLeft: '105px'}}>Ordermanagement</div></></h2>
                    <Card className="px-5 py-5" id="form1" style={{boxShadow: "darkgrey 13px 13px 25px -2px"}}>
                        <Card.Body>
                            {
                                <div className="form-data">
                                    <Form onSubmit={submitLogin}>
                                        <Form.Group className="mb-4">
                                            <Form.Label>{t('Email or username')}</Form.Label>
                                            <Form.Control
                                                type="text"
                                                autoComplete="off"
                                                value={data.login} onChange={e => setData('login', e.target.value)}
                                                isInvalid={!!errors.login}
                                            />
                                            <Form.Control.Feedback type='invalid'>
                                                {/* Die Meldung kommt vom Server und ist dort schon
                                                    passend formuliert. Vorher stand hier ein fester
                                                    englischer Satz über eine ungültige E-Mail — der
                                                    erschien auch dann, wenn schlicht das Passwort
                                                    nicht stimmte, und führte in die Irre. */}
                                                {errors.login}
                                            </Form.Control.Feedback>
                                        </Form.Group>
                                        <Form.Group className="mb-4">
                                            <Form.Label>{t('Password')}</Form.Label>
                                            <Form.Control
                                                type="password"
                                                autoComplete="off"
                                                onChange={e => setData('password', e.target.value)}
                                                isInvalid={!!errors.password}
                                            />
                                            <Form.Control.Feedback type='invalid'>
                                                {errors.password}
                                            </Form.Control.Feedback>
                                        </Form.Group>
                                        <Form.Group className="mb-4">
                                          <Form.Check type="checkbox" label={t('Remember me')} checked={data.remember} onChange={e => setData('remember', e.target.value)}/>
                                        </Form.Group>
                                        <Form.Group className="mb-3">
                                            <Button type="submit" variant="dark" block>{t('Login')}</Button>
                                        </Form.Group>
                                    </Form>
                                </div>
                            }
                        </Card.Body>
                    </Card>
                </Col>
            </Row>
        </div>
    );
}
